module.exports = __webpack_public_path__ + "img/symbol_11.fbb1951d.png";